import { render, staticRenderFns } from "./DropImages.vue?vue&type=template&id=f641c45c&scoped=true&"
import script from "./DropImages.vue?vue&type=script&lang=js&"
export * from "./DropImages.vue?vue&type=script&lang=js&"
import style0 from "./DropImages.vue?vue&type=style&index=0&id=f641c45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641c45c",
  null
  
)

export default component.exports